import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';
import { displayDecimal } from '../../../../_helper/regexHandler';

const DictionaryDataModal = ({ apiEndpoint, isOpen, toggle, selectedDictionary, refreshData }) => {
    const initialData = {
        id: '',
        title: '',
        value: '',
    };

    const validationSchema = useMemo(() => ({
        value: {
            required: true,
            message: 'Değer zorunludur.',
        },
    }), []);

    const {
        formData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode: 'modify',
        selectedItem: selectedDictionary,
        initialData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            selectedItem: { id: selectedDictionary?.id },
            refreshData,
            componentName: 'Sabit Değişken',
            buildPayload: (data) => ({
                title: selectedDictionary?.title || data.title,
                value: data.value ? parseFloat(data.value) : null,
                id: selectedDictionary?.id,
            }),
        },
    });

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>Sabit Değişken Düzenle</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">Parametre Adı</Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title || ''}
                            disabled
                            readOnly
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="value">Değer <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="value"
                            name="value"
                            value={displayDecimal(formData.value ?? '')}
                            onChange={handleInputChange}
                            placeholder="Örn: 20"
                            invalid={!!errors.value}
                        />
                        <FormFeedback>{errors.value}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : 'Güncelle'}
                </Button>
                <Button color="outline-danger" onClick={handleCancel} className="ms-2 rounded-pill">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

DictionaryDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    selectedDictionary: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default DictionaryDataModal;
